 
//import './Copyright.css';

function Copyright() {
  const start = new Date().getFullYear();
  return (
    <p >ADAPTTO © {start} </p>
  );
}

export default Copyright;
